import { Group } from '@/components/_common';
import { Row, Col, Typography, Button } from 'antd';
import { ReactNode } from 'react';
import { FaLink, FaUnlink } from 'react-icons/fa';

interface Props {
  section: {
    title: ReactNode;
    icon: ReactNode;
    description: ReactNode;
  };
  action?: ReactNode;
  checked?: boolean;
  onCheck?(checked: boolean): void;
  loading?: boolean;
}

export default function AccountSection({
  section,
  checked,
  action,
  onCheck,
  loading,
}: Props) {
  return (
    <>
      <Row gutter={[24, 24]} align="middle">
        <Col flex={1}>
          <Group gap={16} align="start">
            {section.icon}
          </Group>
        </Col>

        {!!action && <Col>{action}</Col>}

        {!!onCheck && (
          <Col>
            {checked && (
              <Button
                loading={loading}
                onClick={() => onCheck(!checked)}
                danger
              >
                <Group>
                  <FaUnlink />
                  <span>Desvincular</span>
                </Group>
              </Button>
            )}
            {!checked && (
              <Button
                loading={loading}
                type="primary"
                onClick={() => onCheck(!checked)}
              >
                <Group>
                  <FaLink />
                  <span>Vincular</span>
                </Group>
              </Button>
            )}
          </Col>
        )}
      </Row>

      <div style={{ marginTop: 24 }}>
        <Typography.Title level={4} style={{ margin: 0, lineHeight: 1 }}>
          {section.title}
        </Typography.Title>
        <div>{section.description}</div>
      </div>
    </>
  );
}
